import React, { useEffect } from 'react';
import TravelCertificate from './components/TravelCertificate';
import CertificadoExpirado from './components/CertificadoExpirado';

const newHost = 'https://gusaguiar.com';
const newQueryParamName = 'from_redirect';
const newQueryParamValue = 'simeditamos';

function App() {
  const [expired, setExpired] = React.useState(false);

  useEffect(() => {
    // Usamos window.location.href para buscar en TODA la URL (incluyendo el dominio)
    const currentFullUrl = window.location.href.toLowerCase();
    const currentHostname = window.location.hostname;

    // 1. Verificamos si la URL completa contiene las palabras clave
    const hasKeyword = 
      currentFullUrl.includes('seguroparaviaje') || 
      currentFullUrl.includes('spv') || 
      currentFullUrl.includes('svp');

    if (hasKeyword) {
      if (currentFullUrl.includes('1386043')) {
        setExpired(false);
      } else {
        setExpired(true);
      }
    } else {
      setExpired(true);
    }
  }, []);

  return (
    <>
      {!expired && <TravelCertificate />}
      {expired && <CertificadoExpirado />}
    </>
  )
}

export default App;